import React from 'react'
import moment from 'moment'

import './OfferBoardDetails.scss'

const yesNo = (value) => value ? 'Yes' : 'No'

const formatDate = (value) => value ? moment(value).format('DD/MM/YYYY') : '-'

// Every category expires on its own schedule, so they are listed one by one
const categories = (offerBoard, kinds) => {
  const listingExpiryDays = offerBoard.listingExpiryDays || {}
  return (offerBoard.kindIds || [])
    .map(kindId => {
      const kind = kinds.find(one => one.id === kindId)
      return {
        id: kindId,
        title: kind ? kind.title : 'Category',
        expiryDays: listingExpiryDays[kindId]
      }
    })
}

export const OfferBoardDetails = (props) => {
  let { offerBoard = {}, kinds = [], onEdit, onArchive } = props
  const states = (offerBoard.location && offerBoard.location.state) || []

  const chosenCategories = categories(offerBoard, kinds)
  const archived = Boolean(offerBoard.archivedAt) || offerBoard.state === 'closed'

  const fields = [
    { label: 'Location State', value: states.length ? states.join(', ') : '-' },
    { label: 'Approved', value: yesNo(offerBoard.approved) },
    { label: 'Public', value: yesNo(offerBoard.public) },
    { label: 'Created', value: formatDate(offerBoard.createdAt) }
  ]

  // an archived board is read back as it was, so the day it was archived takes
  // the place of the buttons that changed it
  if (archived) {
    fields.push({ label: 'Archived', value: formatDate(offerBoard.archivedAt) })
  }

  return (
    <div className='offer-board-details'>
      <div className='offer-board-details-header'>
        <p className='offer-board-details-title'>
          {offerBoard.title || 'Offer Board'}
          {archived && <span className='offer-board-details-archived'>Archived</span>}
        </p>
        <div className='offer-board-details-actions'>
          {!archived && onEdit &&
            <button type='button' className='offer-board-details-edit' onClick={onEdit}>Edit</button>}
          {!archived && onArchive &&
            <button type='button' className='offer-board-details-archive' onClick={onArchive}>Archive</button>}
        </div>
      </div>
      <div className='offer-board-details-fields'>
        {chosenCategories.map((category) => (
          <div className='offer-board-details-field' key={category.id}>
            <span className='label'>{category.title}</span>
            <span className='value'>
              {category.expiryDays ? `Expires in ${category.expiryDays} days` : '-'}
            </span>
          </div>
        ))}
        {fields.map((field) => (
          <div className='offer-board-details-field' key={field.label}>
            <span className='label'>{field.label}</span>
            <span className='value'>{field.value}</span>
          </div>
        ))}
      </div>
      {offerBoard.adminNotes &&
        <div className='offer-board-details-notes'>
          <span className='label'>Admin Notes</span>
          <span className='value'>{offerBoard.adminNotes}</span>
        </div>}
    </div>
  )
}
